import { Component, OnInit } from '@angular/core';
import { WebinarpageService } from '../webinarpage.service';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { WebinarsArticleVideoComponent } from './webinars-article-video/webinars-article-video.component';
import { WebinarsArticlePodcastsComponent } from './webinars-article-podcasts/webinars-article-podcasts.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-webinars-article',
  templateUrl: './webinars-article.component.html',
  styleUrls: ['./webinars-article.component.scss'],
  imports: [
    WebinarsArticleVideoComponent,
    WebinarsArticlePodcastsComponent,
    CommonGetstartedComponent,
  ],
})
export class WebinarsArticleComponent implements OnInit {
  getStartedData:any;
  pageData:any;
  constructor(
    private webinarPageService: WebinarpageService,
    private activeRoute: ActivatedRoute,
    private canonical: CanonicalService,
    private posthogService: PosthogService
  ) {}

  async ngOnInit(): Promise<void> {
    // this.activeRoute.params.subscribe((param)=>{
    //   this.webinarPageService.getwebinarArticleData(param.webinararticleid);
    // });
    const id = this.activeRoute.snapshot.params['webinararticleid'];
    this.canonical.setCanonicalURL();
    const fetchedData = await this.webinarPageService.getAllWebinarArticles();
    this.pageData = fetchedData.filter((el) => String(el?.fields?.['blogId'] || '').toLowerCase() === id.toLowerCase())[0];
    const data = this.pageData?.fields;
    if (data != null) {
      let datas = data?.gettingStarted?.fields;
      this.getStartedData = {
        header: datas?.title || '',
        button1: {
          url: datas?.buttons[0]?.fields?.redirectLink || '',
          text: datas?.buttons[0]?.fields?.buttonText || '',
          target: datas?.buttons[0]?.fields?.actionType || '',
        },
        button2: {
          url: datas?.buttons[1]?.fields?.redirectLink || '',
          text: datas?.buttons[1]?.fields?.buttonText || '',
          target: datas?.buttons[1]?.fields?.actionType || '',
        },
      };
    }
    this.posthogService.capturePageViewEvent(id);
  }
}
